import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { Link } from 'react-router-dom';

const stats = [
  { value: '5,000+', label: '漫画总量' },
  { value: '100+', label: '每日更新' },
  { value: '800万+', label: '注册用户' },
  { value: '12', label: '覆盖题材' },
];

const features = [
  {
    icon: 'ri-shield-check-line',
    title: '正版授权',
    description: '所有漫画均获得官方正版授权，支持原创作者，保障阅读品质。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    description: '采用最先进的图片压缩技术，在保证高清画质的同时实现快速加载。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    description: '编辑团队每日精选最新韩漫资源，让你永不落后于更新进度。',
  },
  {
    icon: 'ri-device-line',
    title: '多端适配',
    description: '完美支持电脑、平板、手机等多种设备，随时随地畅享阅读。',
  },
];

const testimonials = [
  {
    name: '王小明',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20casual%20style%2C%20soft%20natural%20lighting&width=120&height=120&seq=avatar-01&orientation=squarish',
    text: '韩漫大全真心好用！更新速度超快，画质也是我看过最好的。现在每天必刷，已经推荐给所有朋友了。',
    role: '忠实读者 · 3年',
  },
  {
    name: '李小美',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%2C%20warm%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20casual%20elegant%20style%2C%20soft%20natural%20lighting&width=120&height=120&seq=avatar-02&orientation=squarish',
    text: '分类特别全，我喜欢的恋爱和校园题材都能找到。阅读体验流畅，完全不卡顿，强烈推荐！',
    role: 'VIP用户 · 2年',
  },
  {
    name: '张大力',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%2C%20confident%20expression%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20modern%20style%2C%20soft%20natural%20lighting&width=120&height=120&seq=avatar-03&orientation=squarish',
    text: '从韩漫大全上线第一天就在用了，见证了平台一步步成长。漫画库越来越丰富，UI也越来越好看。',
    role: '元老用户 · 5年',
  },
];

const faqs = [
  {
    question: '韩漫大全上的漫画都是免费的吗？',
    answer: '是的！韩漫大全上所有漫画目前均提供免费阅读服务。我们致力于为广大读者提供便捷、优质的漫画阅读体验。未来如有付费内容，会提前公告并确保透明公正。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '我们的编辑团队每天都会更新漫画资源，确保您能够及时阅读到最新章节。热门漫画通常每周更新1-2话，部分作品可能因版权方安排有所不同。',
  },
  {
    question: '可以在手机上阅读吗？',
    answer: '当然可以！韩漫大全网站完美适配手机、平板和电脑等多种设备。您只需使用浏览器访问即可，无需下载任何APP，随时随地享受阅读乐趣。',
  },
  {
    question: '漫画的画质如何？',
    answer: '我们采用先进的图片优化技术，所有漫画均提供高清画质。在保证清晰度的同时，也优化了加载速度，让您享受流畅的阅读体验。',
  },
  {
    question: '如何找到我喜欢的漫画类型？',
    answer: '您可以通过首页的分类导航进入对应的题材页面，也可以在分类页面浏览全部类别。我们目前涵盖了奇幻、恋爱、动作、悬疑、科幻、校园、武侠、现实等十二大题材。',
  },
  {
    question: '网站上的漫画是否有版权？',
    answer: '韩漫大全高度重视版权保护，平台上的所有漫画内容均已获得版权方的合法授权。我们坚决支持原创，维护创作者权益。',
  },
];

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="px-4 md:px-6 py-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>

        <section className="py-10 md:py-16 px-4 md:px-6 bg-background-100" aria-label="品牌介绍">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block bg-white dark:bg-foreground-950 text-foreground-700 dark:text-foreground-300 text-xs font-medium px-4 py-1.5 rounded-full mb-4">
                关于韩漫大全
              </span>
              <h1 className="text-3xl md:text-5xl font-bold text-foreground-900 font-heading mb-4">
                让每一个人都能
                <br />
                享受漫画的乐趣
              </h1>
              <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
                韩漫大全创立于2021年，是国内领先的韩国漫画在线阅读平台。我们致力于为广大中文读者提供最新、最全、最优质的韩国漫画阅读体验。
              </p>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-12">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center bg-background-50 rounded-lg p-5">
                  <p className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">{stat.value}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {features.map((feature) => (
                <div key={feature.title} className="bg-background-50 rounded-lg p-5">
                  <div className="w-10 h-10 flex items-center justify-center bg-secondary-100 rounded-lg mb-3">
                    <i className={`${feature.icon} text-lg text-secondary-600`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">{feature.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 px-4 md:px-6" aria-label="用户口碑">
          <div className="max-w-3xl mx-auto text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
              用户口碑
            </h2>
            <p className="text-foreground-500 text-sm">听听读者们怎么说</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
            {testimonials.map((t) => (
              <div key={t.name} className="bg-background-100 rounded-lg p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed">{t.text}</p>
                <div className="flex items-center gap-0.5 mt-3">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-yellow-400 text-xs w-3 h-3 flex items-center justify-center"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="py-10 md:py-16 px-4 md:px-6 bg-background-100" aria-label="联系我们">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
                联系我们
              </h2>
              <p className="text-foreground-500 text-sm">有任何问题或建议？欢迎随时联系我们</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="bg-background-50 rounded-lg p-5 text-center">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-full mx-auto mb-3">
                  <i className="ri-mail-line text-accent-600 text-lg"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-xs text-foreground-500">hello@caishenlicai.com</p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 text-center">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-full mx-auto mb-3">
                  <i className="ri-phone-line text-accent-600 text-lg"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">客服电话</h3>
                <p className="text-xs text-foreground-500">400-888-9999</p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 text-center">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-full mx-auto mb-3">
                  <i className="ri-time-line text-accent-600 text-lg"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">工作时间</h3>
                <p className="text-xs text-foreground-500">周一至周五 9:00-18:00</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 px-4 md:px-6" id="faq" aria-label="常见问题">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
                常见问题
              </h2>
              <p className="text-foreground-500 text-sm">关于韩漫大全，你想知道的都在这里</p>
            </div>
            <div className="flex flex-col gap-4">
              {faqs.map((faq, index) => (
                <details key={index} className="group bg-background-100 rounded-lg overflow-hidden">
                  <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                    <h3 className="text-sm font-semibold text-foreground-900 pr-4">{faq.question}</h3>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-xs text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 px-4 md:px-6 relative overflow-hidden" aria-label="CTA区域">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%2C%20group%20of%20diverse%20characters%20smiling%20and%20waving%2C%20warm%20friendly%20atmosphere%2C%20anime%20inspired%20art%2C%20soft%20pastel%20colors%2C%20wide%20composition%2C%20welcoming%20vibe&width=1920&height=600&seq=cta-bg-about&orientation=landscape"
            className="absolute inset-0 w-full h-full object-cover object-top"
            alt=""
          />
          <div className="absolute inset-0 bg-accent-950/85"></div>
          <div className="relative z-10 text-center max-w-2xl mx-auto">
            <h2 className="text-2xl md:text-4xl font-bold text-white font-heading mb-3">
              加入韩漫大全
            </h2>
            <p className="text-white/70 text-sm md:text-base mb-8">
              数千部正版韩国漫画等你来探索，立即开始你的阅读之旅
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-primary-500 text-white dark:text-foreground-950 text-sm font-medium px-8 py-3 rounded-md hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              立即开始阅读
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于韩漫大全 - 韩国漫画在线阅读平台',
            description: '韩漫大全是国内领先的韩国漫画在线阅读平台，提供最新最全的正版韩国漫画。',
            url: 'https://www.example.com/about',
            inLanguage: 'zh-CN',
            about: {
              '@type': 'Organization',
              name: '韩漫大全',
              url: 'https://www.example.com/',
              description: '韩国漫画免费在线阅读平台',
              foundingDate: '2021',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.example.com/' },
              { '@type': 'ListItem', position: 2, name: '关于我们' },
            ],
          }),
        }}
      />
    </>
  );
}